module.exports = __webpack_public_path__ + "static/media/diners.d4b01e99.png";